import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    TabbedComponent,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useProduct} from '../hooks/useProduct.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {IndexPage as NotificationSubscriptionsPage} from "../../notification-subscriptions/pages/IndexPage.tsx";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";

export const EditPage = () => {

    const {allowedActions} = useVerifiedPermissions();

    const {id: productId} = useParams();

    if (typeof productId === 'undefined') {
        throw new Error('productId is required parameter');
    }

    const {
        record: product,
        updateRecord,
        loading,
    } = useProduct(productId);

    const {
        mode,
        tools,
    } = useEditPageTools();

    if (loading || !product) {
        return <PlatformLoader message='Loading product...Please wait'/>;
    }

    const tabs = [];
    if (allowedActions.includes('ListNotificationSubscriptions')) {
        tabs.push({
            title: 'Notification Subscriptions',
            component: <NotificationSubscriptionsPage/>
        });
    }

    return (
        <FormPageLayout
            title={product.productTitle ? product.productTitle : product.id}
            pageNavigation={<EditPageNavigation component={product}/>}
            tools={tools}
        >

            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={product}
                    />

                    <TabbedComponent tabs={tabs}></TabbedComponent>

                </Stack>
                :
                <RecordForm
                    record={product}
                    handleSubmit={updateRecord}
                />}

        </FormPageLayout>
    );
};
